import { render } from "./IndexInventoryStatusPage.vue?vue&type=template&id=5f74c5d2"
import script from "./IndexInventoryStatusPage.vue?vue&type=script&lang=js"
export * from "./IndexInventoryStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__